import { render, staticRenderFns } from "./AddLabel.vue?vue&type=template&id=40e1c9bb&scoped=true"
import script from "./AddLabel.vue?vue&type=script&lang=js"
export * from "./AddLabel.vue?vue&type=script&lang=js"
import style0 from "./AddLabel.vue?vue&type=style&index=0&id=40e1c9bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e1c9bb",
  null
  
)

export default component.exports